import React, { Component } from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';

var monthNames = {
    "January": 1,
    "February": 2,
    "March": 3,
    "April": 4,
    "May": 5,
    "June": 6,
    "July": 7,
    "August": 8,
    "September": 9,
    "October": 10,
    "November": 11,
    "December": 12
};
class Body extends Component {
    constructor(props,context){
        super(props,context);
    }

    getTotalOrders = () => {
        let totalOrders = 0;
        this.props.annualSales.map((item) =>
            totalOrders += item.numberOfOrders
        );
        return totalOrders;
    };

    getTotalNetSales = () => {
        let netSalesAmount = 0;
        this.props.annualSales.map((item) =>
        netSalesAmount += item.netSalesAmount
        )
        return netSalesAmount.toFixed(2);
    }

    getTotalGrossSales = () => {
        let totalGrossSales = 0;
        this.props.annualSales.map((item) =>
            totalGrossSales += item.grossSales
        )
        return totalGrossSales.toFixed(2);
    }

    getTaxes = () => {
        let taxes = 0;
        this.props.annualSales.map((item) =>
            taxes += item.taxes
        )
        return taxes;
    }

    getAverageOrder = () => {
        return ((this.getTotalNetSales() / this.getTotalOrders()) || 0).toFixed(2);
    }

    getBranchName = (id) => {
        return this.props.userBranch[id - 1].name;
    }

    render() {
        const avgOrders = parseFloat(this.getAverageOrder());
        const totalNetSales = parseFloat(this.getTotalNetSales());
        const TotalGrossSales = parseFloat(this.getTotalGrossSales());
        const theYear = this.props.searchedYear == null ? moment().format('YYYY') : this.props.searchedYear;
        const theBranch = this.props.searchedBranch == null ? this.getBranchName(this.props.loggedBranch) : this.props.searchedBranch;
        const taxes = parseFloat(this.getTaxes());

        return (

            <div className="table-responsive">
                <div className="mt-5">
                    {/* YEAR SUMMARY BOX */}
                    <div className="row m-0 mt_xs">
                        <div className="col-lg-1 col-md-1"></div>
                        <div className="col-lg-10 col-md-10 col-sm-12">
                            <div className="row m-0 green_box col-4-p-0 col-4-em-0 ptb-30">
                                <div className="sales_label_container">
                                    <label className="label_big_title">TOTAL {theYear}</label>
                                    <p>{theBranch}</p>
                                </div>

                                <div className="col-lg-1 col-md-4 col-sm-4 col-xs-3 m-0 p-0 text-center in_green_box">
                                    <div><b># Orders</b></div>
                                    <h2 className="p-0 m-0 text-muted"><b>{this.getTotalOrders()}</b></h2>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-5  m-0 p-0 pt-2 text-center in_green_box">
                                    <div><b>Total net sales</b></div>
                                    <h2 className="p-0 m-0 money">{getDollarFormat(totalNetSales)}</h2>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-4  m-0 p-0 pt-2 text-center in_green_box">
                                    <div><b>Avg. Order Value</b></div>
                                    <h2 className="p-0 m-0 money">{getDollarFormat(avgOrders)}</h2>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-4  m-0 p-0 pt-2 text-center in_green_box">
                                    <div><b>Gross Sales</b></div>
                                    <h2 className="p-0 m-0 money">{getDollarFormat(TotalGrossSales)}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2"></div>
                    </div>
                    {/* LIST - Months */}
                    <div className="row m-0">
                        {
                            this.props.annualSales.sort((a,b) => monthNames[a.month] - monthNames[b.month]).map((item, index) => {
                                return (
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12" key={index}>
                                        <div className="row m-0 green_box min_height_120">
                                            <div className="sales_label_container"><label>{item.month}</label></div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0 text-center in_green_box">
                                                <div><b># Orders</b></div>
                                                <h2 className="p-0 m-0 text-muted"><b>{item.numberOfOrders}</b></h2>
                                            </div>
                                            <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9  m-0 p-0 pt-2 text-right in_green_box">
                                                <div><b>Total net sales</b></div>
                                                <h2 className="p-0 m-0 mb-4 money">{getDollarFormat((item.netSalesAmount || 0))}</h2>
                                                <span><b>Total Gross sales</b></span>
                                                <h2 className="p-0 m-0 money">{getDollarFormat((item.grossSales || 0))}</h2>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  m-0 p-0 pt-2 text-right">
                                                <h5 className='purpleText'><i>Avg. Order: <span className="money">{item.averageOrder ? getDollarFormat((item.averageOrder || 0)) : "$0"}</span></i></h5>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }

}
export default Body;